// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2peVy","colorSwatch":"style_colorSwatch__BXpIP","colorPickItem":"style_colorPickItem__2WYoN","colorAllOptions":"style_colorAllOptions__3COMM"};